import React from "react";
import calendar from '../images/calendar.gif'
import logo from '../images/mainlogo.png'

const Header = () => {
  return (  
        // <div className="headerSection fade-in slide-in-top">
        // <div className="headerSection slide-in-top"> 
        
        <div className="headerSection">
          <div className="iconLogo">
            <img src={logo} alt="Logo" />
          </div>

          <div className="topCurve"></div>

          <div className="clientName">
            <h3>Ng Teng Fong General Hospital</h3>
          </div>

          <div className="timeDate">
            <div className="dayTime">
              <span className="day">SUN</span><br />
              <span className="time">10:00</span><br />
              <span className="time2">PM</span>
            </div>
            <div className="sepLine"></div>
            <div className="calendar">
              <span className="dd">11</span><br />
              <span className="mm">January</span><br />
              <span className="yyyy">2021</span>
            </div>
            <div className="iconCalendar">
              <img src={calendar} alt="Date" height="100" width="100" />
            </div>
          </div>
        </div> 


      

  );
};

export default Header;